<template>
  <!-- 通报批评-扣分列表 -->
  <div class="deduct_list">
    <div class="head pb-12">
      <div class="head_left flex flex-col">
        <div> {{ type == 'E2' ? '受到上级问责、约谈、通报批评情况' : '涉旅企业警告、整改、取消等级' }}</div>
        <div class="flex-row  text-12 text-[#999999] font-400">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>
      </div>
      <div class="head_right">
        <p v-if="deduction != 0" class="score">-{{ deduction }}分</p>
        <p v-else class="noScore">未扣分</p>
      </div>
    </div>
    <div class="save_list mt-24" v-if="eCategoryList.length > 0">
      <div class="record_list" v-if="type == 'E2'">
        <div class="record_item">

          <div>
            <!-- <div class="record_title">
              <span>受到上级问责、约谈、通报批评情况</span>
            </div> -->
            <div class="deduct_item pb-12  border-0 border-solid border-b-[1px] border-b-[#EEEEEE] last:border-0" v-for="item in eCategoryList" :key="item.id">
              <div class="reason">
                <span>受处理类型：</span>
                <span>{{ item.punishTypeCN}}</span>
              </div>
              <div class="reason deal_cont">
                <div class="left_cont">
                  <span>受处理内容：</span>
                  <span class="deal_c">{{ item.punishDesc }}</span>
                </div>
                <div class="cont">
                  <span v-if="item.audited == 0" class="status">未审核</span>
                  <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
                </div>
              </div>
              <div class="reason">
                <span>受处理时间：</span>
                <span>{{ item.punishTime.split('-')[0] + '年' + item.punishTime.split('-')[1] + '月' +
                  item.punishTime.split('-')[2] + '日' }}</span>
              </div>
              <div class="see_more" @click="goDetail(item)">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="record_list" v-if="type == 'E3'">
        <div class="record_item">

          <div>
            <!-- <div class="record_title">
              <span>涉旅企业警告、整改、取消等级</span>
            </div> -->
            <div class="deduct_item pb-12  border-0 border-solid border-b-[1px] border-b-[#EEEEEE] last:border-0" v-for="item in eCategoryList" :key="item.id">
              <div class="reason">
                <span>受处理类型：</span>
                <span>{{ item.punishTypeCN}}</span>
              </div>
              <div class="reason deal_cont">
                <div class="left_cont">
                  <span>受处理内容：</span>
                  <span class="deal_c">{{ item.punishDesc }}</span>
                </div>
                <div class="cont">
                  <span v-if="item.audited == 0" class="status">未审核</span>
                  <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
                </div>
              </div>
              <div class="reason">
                <span>受处理时间：</span>
                <span>{{ item.punishTime.split('-')[0] + '年' + item.punishTime.split('-')[1] + '月' +
                  item.punishTime.split('-')[2] + '日' }}</span>
              </div>
              <div class="see_more" @click="goDetail(item)">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="eCategoryList.length == 0" class="no_data">
      <div class="no_data_img">
        <img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
      </div>
      <div class="no_data_tip">
        <p>该州市未发生</p>
        <p>{{ type == 'E2' ? '受到上级问责、约谈、通报批评情况' : '涉旅企业警告、整改、取消等级' }}</p>
      </div>

    </div>
  </div>
</template>

<script>
// import api from "@/service/modules/appraiseNew.js";
// import commonAPI from "@/utils/common";
// import btnauth from "../appraiseNew/components/btnauth";
import { mapState ,mapMutations } from "vuex";

export default {
  name: 'notificationDetail',
  components: {
    // btnauth,
  },
  data() {
    return {
      deduction: this.$route.query.deduction,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      quarterName: this.$route.query.quarterName,
      areaName: this.$route.query.areaName,
      type: this.$route.query.type,
    };
  },
  created() {
    console.log('output->[ created ] >', this.$route)

  },
  beforeDestroy() {
    setECategoryList([])
  },
  computed: {
    ...mapState('appraise', ['eCategoryList'])
  },

  methods: {
    ...mapMutations('appraise', ['setECategoryList']),
    // 查看详情
    goDetail(item) {
      const { area, year, quarter } = this.$route.query;
      // this.$router.push(`/appraise/deductDetailNotifi?id=${item.id}`);
      this.$router.push({
        path: "/appraise/deductDetailNotifi",
        query: {
          id: item.id,
          area,
          year,
          quarter,
          // userAuthoirese: this.userAuthoirese,
          // updateAuth: this.updateAuth,
          // deleteAuth: this.deleteAuth,
          // accidentListAuth: this.accidentListAuth,
          // meetListAuth: this.meetListAuth,
          // abarbeitungListAuth: this.abarbeitungListAuth
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.deduct_list {
  height: 100%;
  background-color: #fbfbfb;
}

.head {
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;
  background-color: #fff;
}

.head_left {
  padding-top: 20px;
  width: 276px;
  color: #333;
  font-size: 20px;
  line-height: 28px;
  font-weight: bold;
}

.head_right {
  text-align: right;

  .score {
    padding: 22px 0 8px;
    color: #ff4d4d;
    font-size: 22px;
    line-height: 22px;
    font-weight: 500;
  }

  .noScore {
    padding: 22px 0 8px;
    color: #999;
    font-size: 22px;
    line-height: 22px;
    font-weight: 500;
  }

  .percent {
    font-size: 14px;
    font-weight: 500;
    color: #999;
  }
}

.save_list {
  padding: 0 12px;

  .list_top {
    display: flex;
    justify-content: space-between;
  }

  .add_btn {
    margin: 24px 0 12px;
    width: 70px;
    height: 30px;

    span {
      line-height: 30px;
    }

    .plus {
      padding-right: 3px;
      line-height: 28px;
      vertical-align: top;
    }
  }

  .total {
    margin: 32px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333;

    span {
      color: #ff8c19;
      font-weight: 500;
    }
  }

  .record_list {
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
  }

  .items {
    margin-bottom: 16px;
  }

  .deduct_score {
    font-size: 12px;
    font-weight: 500;
    color: #ff4d4d;
  }

  .record_item {
    padding: 16px  16px 0 16px;
    // border-bottom: 1px solid #eee;

    .status {
      font-size: 12px;
      color: #ff8c19;
    }

    .deduct_item {
      margin-bottom: 16px;
    }

    .record_title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      color: #333;
      font-size: 14px;
      font-weight: bold;
    }

    &:last-child {
      border: 0;
    }

    .reason {
      margin-bottom: 8px;
      font-size: 12px;
      color: #666;
    }

    .deal_cont {
      display: flex;
      justify-content: space-between;

      .left_cont {
        width: 265px;
        padding: 3px 0 0 0;
        margin-top: -3px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .see_more {
      padding-top: 8px;
      font-size: 12px;
      color: #36b374;

      img {
        margin-left: 2px;
        display: inline-block;
        width: 12px;
        height: 12px;
        vertical-align: top;
      }
    }
  }
}

.no_data {
  .no_data_img {
    padding: 72px 0 20px;

    img {
      margin: 0 auto;
      width: 74px;
      height: 62px;
    }
  }

  .no_data_tip {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: center;
  }

  .add_btn_box {
    padding: 32px 0;
    background-color: transparent;
    text-align: center;

    .add_btns {
      width: 70px;
      height: 30px;
    }

    span {
      line-height: 30px;
    }

    .plus {
      padding-right: 3px;
      line-height: 28px;
      vertical-align: top;
    }
  }
}
</style>